// Rótulos e textos do módulo Pedidos (o que o cliente procura). As chaves são as mesmas do backend (painel-node src/pedidoDados.js).
export const TIPOS_IMOVEL = [
  ['casa', 'Casa'], ['sobrado', 'Sobrado'], ['apartamento', 'Apartamento'], ['cobertura', 'Cobertura'], ['kitnet', 'Kitnet'],
  ['terreno', 'Terreno'], ['comercial', 'Comercial'], ['galpao', 'Galpão'], ['chacara', 'Chácara'], ['sitio', 'Sítio'],
  ['fazenda', 'Fazenda'], ['rural', 'Rural'],
];
export const PAGAMENTOS = [
  ['', 'Não informado'], ['financiamento', 'Financiamento'], ['fgts', 'FGTS'], ['misto', 'Financiamento + FGTS/entrada'], ['avista', 'À vista'],
];
export const STATUS = [['aberto', 'Aberto'], ['atendido', 'Atendido'], ['cancelado', 'Cancelado']];
export const COR_STATUS = { aberto: 'primary', atendido: 'success', cancelado: 'secondary' };
export const FLEXIVEIS = [
  ['tipoImovel', 'Tipo'], ['bairros', 'Bairro'], ['dormitorios', 'Dormitórios'], ['garagens', 'Vagas'], ['emCondominio', 'Condomínio'],
];

const rotulo = (lista, chave) => (lista.find(([k]) => k === chave) || [])[1] || '';
export const dinheiro = (v) => `R$ ${Number(v).toLocaleString('pt-BR', { maximumFractionDigits: 0 })}`;

export function dataHora(v) {
  if (!v) return '';
  return new Date(v).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

// "Casa · de R$ 200.000 até R$ 300.000 · 3+ dorm. · Abílio Pedro ou Centro · financiamento" — o pedido em uma linha
export function resumoPedido(p) {
  const valor = p.valorMin && p.valorMax ? `de ${dinheiro(p.valorMin)} até ${dinheiro(p.valorMax)}` : p.valorMax ? `até ${dinheiro(p.valorMax)}` : p.valorMin ? `a partir de ${dinheiro(p.valorMin)}` : '';
  return [
    p.finalidade === 'locacao' ? 'Locação' : null,
    p.tipoImovel ? rotulo(TIPOS_IMOVEL, p.tipoImovel) : 'Imóvel',
    valor ? `${valor}${p.valorAproximado ? ' (aprox.)' : ''}` : null,
    p.dormitorios ? `${p.dormitorios}+ dorm.` : null,
    p.garagens ? `${p.garagens}+ vagas` : null,
    p.bairros?.length ? p.bairros.join(' ou ') : null,
    p.condominios?.length ? `cond. ${p.condominios.join(' ou ')}` : p.emCondominio === true ? 'em condomínio' : p.emCondominio === false ? 'fora de condomínio' : null,
    p.pagamento ? rotulo(PAGAMENTOS, p.pagamento).toLowerCase() : null,
  ].filter(Boolean).join(' · ');
}
